
import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import Icon from 'UI/FontAwesomeIcon'
import { REMOVE_FROM_LOGICMONITOR } from './Queries'
import { isEmpty } from 'lodash'
import { Query } from '../../../utilities/incognitaAPI'

const DeletePopup = ({
  asset,
  setAsset,
  setAlert,
  reloadTable
}) => {
  const [loading, setLoading] = useState(false)

  const handleClose = () => setAsset(undefined)

  const destroy = () => {
    setLoading(true)

    Query(REMOVE_FROM_LOGICMONITOR, { id: asset.id })
      .then(res => {
        if(isEmpty(res.removeLogicmonitorMonitorableAssetFromLogicmonitor.errors)) {
          setLoading(false)
          setAsset(undefined)
          reloadTable()
          setAlert({
            text: 'Monitorable Asset has been successfully removed from logicmonitor!',
            variant: 'success'
          })
        }
      })
  }

  return (
    <div
      className="modal show"
      style={{ display: 'block', position: 'initial' }}
    >
      <Modal show={asset} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to remove this logicmonitor monitorable asset?
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-danger" onClick={handleClose}>
            Discard
          </Button>

          <Button variant="primary" onClick={destroy}>
            {loading && <Icon className="mr-1 animate-spin" icon="spinner" />}
            Remove
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
export default DeletePopup